import { IContextProps, IElement, IElementType } from '@routes/private/Editor/types';
import { findElementById, sameElementsTypes } from "@utils/editor";
import {IShapeCustomAttributes, IShapeStarAttributes, IShapeRhombusAttributes, IShapeCircleAttributes, IShapeEllipseAttributes, IShapeRectangleAttributes, IShapeTriangleAttributes, ITextAttributes} from 'routes/private/Editor/types';
import { componentToHex } from './userUtils';

export const transformToHex = (color: string) => {
    if (color.indexOf('rgb') >= 0) {
        let colorArray = color.split(/,/).map(rgbColor => {return parseInt(rgbColor.replace(/[^\d]/g, ''))});
        if (colorArray.length === 3 && Object.values(colorArray).every(c => !Number.isNaN(c))) {
            return `#${componentToHex(colorArray[0])}${componentToHex(colorArray[1])}${componentToHex(colorArray[2])}`;
        }
    }
    return color;
}

export const isWhite = (color:string) => {
    return color.toUpperCase()==="#FFFFFF" || color.toUpperCase()==="FFFFFF" || color.toUpperCase()==="WHITE" || color.toLowerCase()==="#ffffffff"; 
}

export const isCloseToWhite = (color:string) => {
    let colorHex = hexFormat(color);
    let result = parseInt(color.substring(1, 3), 16) + parseInt(color.substring(3, 5), 16) + parseInt(color.substring(5, 7), 16);
    return (result>=750);
}

export const hexFormat = (str:string) => {
    str = str.toLowerCase();
    str = str.length >7 ? str.substring(0,7) : str;
    
    if (/^#([0-9a-f]{3}|[0-9a-f]{6})$/ig.test(str)) {
        str = str.length == 3 ? str.replace(/(.)/g, '$1$1') : str;
        return str;
    }
  
    return "";
}

export const getSelectedColor = (selectedElementsId: string[],elementType: string,colorAttribute: string, data: IElement[]): string|undefined => {
    let color: string|undefined = undefined;
    if(selectedElementsId && selectedElementsId.length>0) {
        for(let i=0;i<selectedElementsId.length;i++){
            const element = findElementById(data, selectedElementsId[i]);
            if(element && element.type===elementType) {
                if(color===undefined) {
                    color = element.attributes[colorAttribute!];
                }
                if(color!==element.attributes[colorAttribute!]) return undefined;
            }
        }        
    }
    return color;
}

export const otherElementHasColor = (selectedElementsId: string[],colorAttribute: string, data: IElement[]): boolean => {
    for(let i=0;i<data.length;i++)
    {
        if (!selectedElementsId.includes(data[i].id)) {
            const jsonAttributes = JSON.stringify(data[i].attributes);
            if (jsonAttributes.includes("\"#" + colorAttribute.replace("#","") + "\"")){
                return true;
            }
        }
        if (data[i].children && data[i].children!.length>0)
        {
            const childrenHasColor = otherElementHasColor(selectedElementsId, colorAttribute, data[i].children!);
            if (childrenHasColor) {
                return true;
            }
        }
    }
    return false;
}